import styled, { css } from 'styled-components';
import Button from './button';
import { style as badgeStyle } from './badge';

const replacer = (str, replaceObj) => {
  if (!replaceObj || !str) {
    return str;
  }
  return Object.entries(replaceObj).reduce((acc, [key, value]) => acc.replace(`{${key}}`, value || ''), str);
};

const Content = styled.div.attrs((props) => {
  if (props.asSpan) {
    return {
      as: 'span',
    };
  }
  return {};
}).attrs((props) => {
  if (props.$content) {
    // strapi 4
    if (props.$content.data?.childMarkdownRemark) {
      const { html, excerpt } = props.$content.data.childMarkdownRemark;
      return {
        dangerouslySetInnerHTML: { __html: replacer(html || excerpt, props.$replace) },
      };
    }
    // strapi 3
    if (props.$content.childMarkdownRemark) {
      const { html, excerpt } = props.$content.childMarkdownRemark;
      return {
        dangerouslySetInnerHTML: { __html: html || excerpt },
      };
    }
    return {
      dangerouslySetInnerHTML: { __html: props.$content },
    };
  }
  return {};
})`
  ${({ $withoutBaseStyles }) => !$withoutBaseStyles && css`
    h1 {
      margin: 0 0 1rem 0; // @TODO: shouldnt this have a :not(:last-child)
      font-size: 1.5rem;
      color: ${({ theme }) => theme.h1Color};
    }
    h2 {
      margin: 0 0 1rem 0; // @TODO: shouldnt this have a :not(:last-child)
      font-size: 1.25rem;
      color: ${({ theme }) => theme.h2Color};
    }
    h3 {
      color: ${({ theme }) => theme.h3Color};
    }
    a:not(${Button}) {
      color: ${({ theme }) => theme.contentLinkColor || theme.primaryColor};

      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
    p {
      margin: 0 0 1rem 0; // @TODO: shouldnt this have a :not(:last-child)
      font-weight: ${({ theme }) => theme.fontWeight};
      line-height: ${({ theme }) => theme.baseLineHeight};
    }
    ul {
      margin: 0 0 1rem 0; // @TODO: shouldnt this have a :not(:last-child)
      padding-left: 0;
      line-height: ${({ theme }) => theme.baseLineHeight};
      font-weight: ${({ theme }) => theme.fontWeight};
      list-style: none;

      li {
        position: relative;
        padding-left: 1rem;

        &::before {
          content: "•";
          position: absolute;
          top: -1px;
          left: 0;
          color: ${({ theme }) => theme.primaryColor};
        }
      }
    }
    ol {
      margin: 0 0 1rem 0; // @TODO: shouldnt this have a :not(:last-child)
      line-height: ${({ theme }) => theme.baseLineHeight};
      font-weight: ${({ theme }) => theme.fontWeight};
    }
    address {
      font-style: normal;
      line-height: ${({ theme }) => theme.baseLineHeight};
    }
    img {
      max-width: 100%;
      vertical-align: middle;
    }
    iframe {
      max-width: 100%;
    }
    table {
      line-height: ${({ theme }) => theme.baseLineHeight};
    }
    table.full-width {
      width: 100%;
    }
    table:not(.no-styling) {
      border-collapse: collapse;
      border-spacing: 0;

      @media all and (max-width: ${({ theme }) => theme.breakingpoints.md}) {
        display: block;
        overflow-x: scroll;
        white-space: nowrap;
        padding-bottom: 0.25rem;
      }

      th, td {
        border-top: 1px solid #ddd;
        vertical-align: top;
        padding: 0.4rem;
      }

      td {
        font-weight: normal;
      }

      tr:nth-child(odd) > td {
        background-color: #fff;
        color: ${({ theme }) => theme.fontColor};
      }
      tr:nth-child(even) > td,
      th {
        background-color: #f9f9f9;
        color: ${({ theme }) => theme.fontColor};
      }
    }

    figcaption {
      ${badgeStyle}
    }
  `}

  ${({ $textAlign }) => css`
    text-align: ${$textAlign};
  `}

  ${({ $contentTheme }) => $contentTheme === 'light' && css`
    && {
      color: white;

      address,
      table,
      p,
      li,
      h1,
      h2,
      h3,
      h3 {
        color: inherit;
        text-shadow: var(--light-theme-text-shadow);
        a {
          color: inherit;
        }
      }
    }
  `}
`;

export default Content;
